import { DayPicker }from "react-day-picker";
import { sv } from "react-day-picker/locale";

// eslint-disable-next-line import/no-unresolved
import "react-day-picker/dist/style.css";

import "./DatePicker.scss";

type Props = {
  onChange: (date:Date) => void;
  value: Date;
  disabledDays?: (date: Date) => boolean
}

function DatePicker({ onChange, value, disabledDays = (date) => false }:Props) {
  return (
    <DayPicker
      disabled={disabledDays}
      selected={value}
      locale={sv}
      className="datepicker"
      onDayClick={(date)=>onChange(date)}
    />
  );
}

export default DatePicker;
